let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8Bc3h")).then(() => parcelRequire('gT3MM'));